// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navHead {
    color: teal;
    font-size: 20px;
    font-weight: bold;
    height: 65px
}
.info {
    font-size: 13px;
}

.cursorPointer {
  cursor: pointer;
}

/* 
.oil{
  background: url('/assets/image/actionsImages/OIL.jpg') no-repeat 0 0;
  height: 70px;
  width: 170px;
  margin: 20px;
  padding-bottom: 80px;
  margin-top: 40px;
}

.coolant{
  background: url('assets/image/actionsImages/COOLANT.jpg') no-repeat 0 0;
  height: 70px;
  width: 170px;
  margin: 20px;
  padding-bottom: 80px;
  margin-top: 40px;
}
.diesel{
  background: url('assets/image/actionsImages/DIESEL.jpg') no-repeat 0 0;
  height: 70px;
  width: 170px;
  margin: 20px;
  padding-bottom: 80px;
  margin-top: 40px;
}
.def{
  background: url('assets/image/actionsImages/DEF.jpg') no-repeat 0 0;
  height: 70px;
  width: 170px;
  margin: 20px;
  padding-bottom: 80px;
  margin-top: 40px;
}
.ng{
  background: url('assets/image/actionsImages/NG.jpg') no-repeat 0 0;
  height: 70px;
  width: 170px;
  margin: 20px;
  padding-bottom: 80px;
  margin-top: 40px;
} */

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/analyze-sample/view-report-home/view-report-home.component.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB;AACJ;AACA;IACI,eAAe;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyCG;;AAEH,ogEAAogE","sourcesContent":["\r\n.navHead {\r\n    color: teal;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    height: 65px\r\n}\r\n.info {\r\n    font-size: 13px;\r\n}\r\n\r\n.cursorPointer {\r\n  cursor: pointer;\r\n}\r\n\r\n/* \r\n.oil{\r\n  background: url('/assets/image/actionsImages/OIL.jpg') no-repeat 0 0;\r\n  height: 70px;\r\n  width: 170px;\r\n  margin: 20px;\r\n  padding-bottom: 80px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.coolant{\r\n  background: url('assets/image/actionsImages/COOLANT.jpg') no-repeat 0 0;\r\n  height: 70px;\r\n  width: 170px;\r\n  margin: 20px;\r\n  padding-bottom: 80px;\r\n  margin-top: 40px;\r\n}\r\n.diesel{\r\n  background: url('assets/image/actionsImages/DIESEL.jpg') no-repeat 0 0;\r\n  height: 70px;\r\n  width: 170px;\r\n  margin: 20px;\r\n  padding-bottom: 80px;\r\n  margin-top: 40px;\r\n}\r\n.def{\r\n  background: url('assets/image/actionsImages/DEF.jpg') no-repeat 0 0;\r\n  height: 70px;\r\n  width: 170px;\r\n  margin: 20px;\r\n  padding-bottom: 80px;\r\n  margin-top: 40px;\r\n}\r\n.ng{\r\n  background: url('assets/image/actionsImages/NG.jpg') no-repeat 0 0;\r\n  height: 70px;\r\n  width: 170px;\r\n  margin: 20px;\r\n  padding-bottom: 80px;\r\n  margin-top: 40px;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
